import { Component, Emit, Prop, Vue } from 'vue-property-decorator';
import { DataTableHeader } from 'vuetify';
import { Media } from '@/models/Report';

@Component<AttachmentTable>({
  components: {
  },
})
export default class AttachmentTable extends Vue {
  @Prop()
  protected attachments!: Media[];

  @Prop({ default: false })
  protected pagination!: boolean

  @Prop({ default: false })
  protected canEdit!: boolean

  @Prop({ default: true })
  protected canAdd!: boolean

  @Prop({ default: false })
  protected canDelete!: boolean

  @Prop({ default: false })
  protected showPoints!: boolean

  @Emit()
  public viewAttachment(id: string): string {
    return id;
  }

  @Emit()
  protected editAttachment(attachment: Media): Media {
    return attachment;
  }

  @Emit()
  protected deleteAttachment(attachment: Media): Media {
    return attachment;
  }

  protected get headers(): DataTableHeader[] {
    return [
      {
        text: 'Bijlage',
        value: 'file_name',
      },
      {
        text: 'Beschrijving',
        value: 'description',
        sortable: false,
      },
      ...this.$store.getters.isBureau ? [{
        text: 'Zichtbaar voor herstelbedrijf',
        value: 'hin_show_to_all',
      }] : [],
      ...this.showPoints ? [{
        text: 'Aantal opleverpunten',
        value: 'amount_of_kpi_points',
      }] : [],
      {
        text: 'Geüpload door',
        value: 'uploaded_by',
      },
      {
        text: 'Aangemaakt op',
        value: 'created_at',
      },
      {
        text: 'Acties',
        value: 'actions',
        sortable: false,
        align: 'end',
        class: 'text-right',
      },
    ];
  }
}
